import { Aurelia, PLATFORM } from 'aurelia-framework';
import { Router, RouterConfiguration } from 'aurelia-router';
import { AuthorizationServiceStep } from '../../services/authorization-service';

export class App {
    router: Router;

    configureRouter(config: RouterConfiguration, router: Router) {
        config.title = 'Licensing Dashboard';
        config.addPipelineStep('authorize', AuthorizationServiceStep); // Add the step globally to require authorization at any page

        config.map([{
            route: ['', 'home'],
            name: 'home',
            settings: { icon: 'home' },
            moduleId: PLATFORM.moduleName('../home/home'),
            nav: false,
            title: 'Home'
        },{
            route: ['licensing-overview'],
            name: 'licensing-overview',
            settings: { icon: 'certificate' },
            moduleId: PLATFORM.moduleName('../licensing-overview/licensing-overview'),
            nav: false,
            title: 'Licensing Overview'
        },{
            route: ['licensing-overview-satellite'],
            name: 'licensing-overview-satellite',
            settings: { icon: 'certificate' },
            moduleId: PLATFORM.moduleName('../licensing-overview/licensing-overview-satellite'),
            nav: false,
            title: 'Licensing Overview (Satellite)'
        },{
            route: ['register-organization'],
            name: 'register-organization',
            settings: { icon: 'pencil' },
            moduleId: PLATFORM.moduleName('../register-organization/register-organization'),
            nav: false,
            title: 'Register organization'
        },{
            route: ['error'],
            name: 'error',
            settings: { icon: 'home' },
            moduleId: PLATFORM.moduleName('../error/error'),
            nav: false,
            title: 'Error'
        }]);

        this.router = router;


    }
}



// WEBPACK FOOTER //
// ./ClientApp/app/components/app/app.ts